import { jsx, jsxs } from "react/jsx-runtime";
const SvgJ = (props) => /* @__PURE__ */ jsxs("svg", { "data-name": "Group 22", xmlns: "http://www.w3.org/2000/svg", width: "5.25rem", height: "5.25rem", viewBox: "0 0 142.755 142.755", ...props, children: [
  /* @__PURE__ */ jsx("defs", { children: /* @__PURE__ */ jsx("clipPath", { id: "yyo9d9tiqa", children: /* @__PURE__ */ jsx("path", { "data-name": "Rectangle 25", d: "M0 0h142.755v142.755H0z" }) }) }),
  /* @__PURE__ */ jsxs("g", { "data-name": "Group 21", style: {
    clipPath: "url(#yyo9d9tiqa)"
  }, children: [
    /* @__PURE__ */ jsx("path", { "data-name": "Path 12", d: "M137.825 28.738 28.739 137.824a16.834 16.834 0 0 1-23.808-23.807L114.017 4.93a16.835 16.835 0 0 1 23.808 23.808" }),
    /* @__PURE__ */ jsx("path", { "data-name": "Path 13", d: "M114.017 137.824 4.931 28.738A16.834 16.834 0 1 1 28.738 4.93l109.087 109.086a16.835 16.835 0 0 1-23.808 23.808" })
  ] })
] });
export default SvgJ;
